// extracted by mini-css-extract-plugin
export var circles = "Location-module--circles--6d2a5";
export var container = "Location-module--container--702e4";
export var core = "Location-module--core--23eb4";
export var hover = "Location-module--hover--0a327";
export var links = "Location-module--links--7f638";
export var location = "Location-module--location--b4496";
export var modal = "Location-module--modal--61476";
export var name = "Location-module--name--3d100";
export var pulse = "Location-module--pulse--d81c8";